var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105,
    height: 100,
    viewBox: "0 0 105 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.5952 68.0999C76.8328 68.0999 79.4574 65.5927 79.4574 62.4999C79.4574 59.4071 76.8328 56.8999 73.5952 56.8999C70.3575 56.8999 67.7329 59.4071 67.7329 62.4999C67.7329 65.5927 70.3575 68.0999 73.5952 68.0999Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.5951 72.5C69.7742 72.5 62.1323 74.3 61.8706 77.9C64.4877 81.45 68.7797 83.75 73.5951 83.75C78.4105 83.75 82.7026 81.45 85.3196 77.9C85.0579 74.3 77.4161 72.5 73.5951 72.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.8293 40.45V16.35L39.5731 0L0.316895 16.35V40.9C0.316895 63.6 17.0662 84.85 39.5731 90C42.4519 89.35 45.226 88.4 47.9477 87.25C50.8325 91.1906 54.6706 94.4075 59.1358 96.6273C63.6011 98.8471 68.5614 100.004 73.5951 100C90.9202 100 105 86.55 105 70C105 55.15 93.6943 42.85 78.8293 40.45ZM42.1902 70C42.1902 72.8 42.6089 75.55 43.394 78.1C42.1378 78.65 40.8816 79.2 39.5731 79.6C22.9808 74.6 10.7852 58.4 10.7852 40.9V22.9L39.5731 10.9L68.361 22.9V40.45C53.496 42.85 42.1902 55.15 42.1902 70ZM73.5951 90C62.0276 90 52.6585 81.05 52.6585 70C52.6585 58.95 62.0276 50 73.5951 50C85.1626 50 94.5318 58.95 94.5318 70C94.5318 81.05 85.1626 90 73.5951 90Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/Admin.3ee5a5448cdcaa1dac4143c4fe4a51c3.svg";
export { ForwardRef as ReactComponent };